"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.GuardManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "guard",
                type: "address"
            },
        ],
        name: "ChangedGuard",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "guard",
                type: "address"
            },
        ],
        name: "setGuard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506101a0806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063e19a9dd914610030575b600080fd5b61004361003e36600461012d565b610045565b005b61004d6100be565b7f4a204f620c8c5ccdca3fd54d003badd85ba500436a431f0cbda4f558c93c34c881815560405173ffffffffffffffffffffffffffffffffffffffff831681527f1151116914515bc0891ff9047a6cb32cf902546f83066499bcf8ba33d2353fa29060200160405180910390a15050565b33301461012b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600560248201527f4753303331000000000000000000000000000000000000000000000000000000604482015260640160405180910390fd5b565b60006020828403121561013f57600080fd5b813573ffffffffffffffffffffffffffffffffffffffff8116811461016357600080fd5b939250505056fea26469706673582212203fbcad6bd06a52af6c81dd893ea08841e06cc93a36688944675f5c8c9e5b171764736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var GuardManager__factory = /** @class */ (function (_super) {
    __extends(GuardManager__factory, _super);
    function GuardManager__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    GuardManager__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    GuardManager__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    GuardManager__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    GuardManager__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    GuardManager__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    GuardManager__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    GuardManager__factory.bytecode = _bytecode;
    GuardManager__factory.abi = _abi;
    return GuardManager__factory;
}(ethers_1.ContractFactory));
exports.GuardManager__factory = GuardManager__factory;
